import { render } from "./parasut.vue?vue&type=template&id=5f3836fb&scoped=true"
import script from "./parasut.vue?vue&type=script&lang=js"
export * from "./parasut.vue?vue&type=script&lang=js"

import "./parasut.vue?vue&type=style&index=0&id=5f3836fb&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3836fb"]])

export default __exports__